import ConstructionLobbyMenu from './construction-lobby-menu';
export default ConstructionLobbyMenu;